export const applyGridPersistence = (gridOptions, gridId, options = {}) => {
  const STORAGE_KEY = `ag-grid-state-${gridId}`;
  let isInternalOperation = false;

  const saveState = (params) => {
    if (isInternalOperation) return;
    const columnApi = params.columnApi || gridOptions.columnApi;
    if (!columnApi) return;
    
    const state = {
      colState: columnApi.getColumnState(),
      groupState: columnApi.getColumnGroupState(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  };

  const restoreState = (params) => {
    const columnApi = params.columnApi || gridOptions.columnApi;
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved || !columnApi) return false;

    try {
      isInternalOperation = true;
      const state = JSON.parse(saved);
      if (state.colState) {
        columnApi.applyColumnState({
          state: state.colState,
          applyOrder: true
        });
      }
      if (state.groupState) columnApi.setColumnGroupState(state.groupState);
      
      // Keep operation lock a bit longer to let the grid settle
      setTimeout(() => { isInternalOperation = false; }, 200);
      return true;
    } catch (e) {
      console.error('Failed to restore grid state', e);
      isInternalOperation = false;
      return false;
    }
  };

  // Expose restore function for manual calls (e.g. after server switch)
  gridOptions.restoreSavedState = () => {
    return restoreState({ columnApi: gridOptions.columnApi });
  };

  const originalOnGridReady = gridOptions.onGridReady;
  gridOptions.onGridReady = (params) => {
    if (originalOnGridReady) originalOnGridReady(params);
    
    // Crucial: Wait for the container to be fully rendered before restoring/fitting
    setTimeout(() => {
      const restored = restoreState(params);
      if (!restored) {
        params.api.sizeColumnsToFit();
        saveState(params); // Save initial fit
      }
    }, 150);
  };

  const originalGetContextMenuItems = gridOptions.getContextMenuItems;
  gridOptions.getContextMenuItems = (params) => {
    let items = [];
    if (typeof originalGetContextMenuItems === 'function') {
      items = originalGetContextMenuItems(params);
    } else {
      items = ['copy', 'copyWithHeaders', 'separator', 'export'];
    }

    items.push('separator');
    items.push({
      name: 'Reset Table Layout',
      icon: '<i class="fa fa-refresh text-warning"></i>',
      action: () => {
        isInternalOperation = true;
        localStorage.removeItem(STORAGE_KEY);
        params.columnApi.resetColumnState();
        params.columnApi.resetColumnGroupState();
        
        // Force a fresh fit
        params.api.sizeColumnsToFit();
        
        // Save the result of sizeColumnsToFit immediately as the new baseline
        setTimeout(() => {
          saveState(params);
          isInternalOperation = false;
          if (window.iziToast) {
            window.iziToast.info({ title: 'Reset', message: 'Table layout restored and saved.' });
          }
        }, 300);
      }
    });

    return items;
  };

  const saveEvents = ['onColumnResized', 'onColumnMoved', 'onColumnVisible', 'onSortChanged'];
  saveEvents.forEach(event => {
    const original = gridOptions[event];
    gridOptions[event] = (params) => {
      if (original) original(params);
      saveState(params);
    };
  });

  return gridOptions;
};